import React from "react";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import PaymentBankTransferDetailViewModel from "viewModels/finance/payments/bankTransfer/paymentBankTransferDetailViewModel";
import DetailView from "views/common/detailView";
import { formatAmount } from "utils/localizations";
import SectionWrapper from "./bankTransferSectionView";

const BankTransferDetailView: ViewComponent<PaymentBankTransferDetailViewModel> = observer(({ vm }) => {
  const amount = vm.item?.amount ? formatAmount(vm.item.amount) : 0;
  const amountTextClass = vm.isAmountPositive ? "success" : "danger";
  const titleInfo = (
    <div className="mb-3" style={{ fontSize: "1.25rem" }}>
      <span>{vm.variableSymbol}</span>
      <span> / </span>
      <span className={`text-${amountTextClass}`}>{amount}</span>
    </div>
  );

  return (
    <DetailView
      vm={vm}
      titleInfo={titleInfo}
      form={<SectionWrapper vm={vm} />}
      customBackButtonText={vm.translate("backButton")}
    />
  );
});

registerView(BankTransferDetailView, PaymentBankTransferDetailViewModel);
